<!--
 * @Descripttion: diySkin
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-05-19 10:52:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-01-22 15:00:44
-->
<template>
  <div class="diyContent">


    <div class="big_tt">《大转盘抽奖工具+（企业版）》-自定义皮肤专用</div>
	<div class="big_top">
		<el-col>
			<el-row>
				<el-button type="primary" @click="toAdd()">添加自定义皮肤</el-button>
			</el-row>
		</el-col>
	</div>

	<el-table
	  :data="skinList"
	  cell-class-name="cell-class"
	  style="width: 100%; max-width: 1200px; margin:0 auto;"
	  v-loading="loading"
	  stripe
	>
	  <el-table-column prop="id" width="100" label="ID"></el-table-column>
	  <el-table-column prop="detail_bg_img"  label="背景小图预览">
		  <template slot-scope="scope">
			<p class="prev_img" style="width: 150px; height: auto; overflow: hidden;">
				<img :src="scope.row.detail_bg_img" alt="" style="width: 100%;" />
			</p>
		  </template>
	  </el-table-column>
	  <el-table-column label="操作" align="right">
		    <template slot-scope="scope">
				<el-button type="primary" @click="toCompile(scope.row)">预览皮肤与编辑</el-button>
				<el-button type="danger" class="delete" @click="toDelete(scope)"> 删除 </el-button>
		  </template>
	  </el-table-column>
	  
	  
	</el-table>
	
	<el-dialog
	  title="添加皮肤"
	  :visible.sync="dialogVisible"
	  width="95%"
	  >
	  <div class="diyFlx">
	    <div class="flx-l">
	      <div class="tips">
	        <p>1. 请先下载素材，根据素材设计图片;<br />2. 点击图片或者上传按钮更换自定义图片;<br />3. 请注意原素材文件格式，上传的图片需与原素材格式保持一致，且单张图片不超过2M;<br /></p>
	        <p><a href="https://sz-lottery.oss-cn-hangzhou.aliyuncs.com/Uploads/skin.rar" target="_black">下载素材</a></p>
	      </div>
	      
	      <el-form ref="form" :model="form" label-width="80px" label-position="top">
	        <el-form-item label="背景图：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleDetailBgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.detail_bg_img" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.detail_bg_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="背景颜色：">
	          <el-color-picker v-model="form.detail_bg_color"></el-color-picker>
	        </el-form-item>
	        <el-form-item label="转盘：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleDzpDialImgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.dzp_dial_img" alt="">
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	              <div slot="tip" class="el-upload__tip"><a :href="form.dzp_dial_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="转盘格子1颜色：">
	          <el-color-picker v-model="form.bg_color_1"></el-color-picker>
	        </el-form-item>
	        <el-form-item label="转盘格子2颜色：">
	          <el-color-picker v-model="form.bg_color_2"></el-color-picker>
	        </el-form-item>
	        <el-form-item label="转盘格子3颜色：">
	          <el-color-picker v-model="form.bg_color_3"></el-color-picker>
	        </el-form-item>
	        <el-form-item label="转盘指针：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleDzpNeedleImgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.dzp_needle_img" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.dzp_needle_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="介绍页背景图：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handlePrizeBgImgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.prize_bg_img" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.prize_bg_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="九宫格盘面背景：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNineDialImgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.nine_dial_img" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.nine_dial_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="九宫格按钮：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNineNeedleImgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.nine_needle_img" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.nine_needle_img" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="九宫格中奖背景：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNinePrizeBgSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.nine_prize_bg" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.nine_prize_bg" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="摇一摇手：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleYaoHandleSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.yao_handle" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.yao_handle" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="摇一摇手底部装饰：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleYaoBottomSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.yao_bottom" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.yao_bottom" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机盒子：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuBoxerSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_boxer" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_boxer" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机球1：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuNall1Success"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_ball1" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_ball1" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机球2：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuNall2Success"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_ball2" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_ball2" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机球3：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuNall3Success"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_ball3" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_ball3" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机球出口：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuWindowSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_window" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_window" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="扭蛋机开始：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'file.html'"
	              :on-progress="handleProgress"
	              :on-success="handleNiuStartSuccess"
	              :show-file-list="false"
	            >
	              <img :src="form.niu_start" alt="">
	              <div slot="tip" class="el-upload__tip"><a :href="form.niu_start" target="_black" style="color:#0d84be">下载素材 >></a></div>
	              <div>  <el-button size="mini" type="primary">上传<i class="el-icon-upload el-icon--right"></i></el-button></div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="自定义音乐：">
	          <div class="imgbox">
	            <el-upload
	              class="upload-demo"
	              ref="upload"
	              :action="baseUrl+'fileMP3'"
	              :on-progress="handleProgress"
	              :on-success="handleMusicSuccess"
	              :headers="headers"
	              :show-file-list="false"
	            >
	              <el-button size="mini" type="primary" style="float: left;">上传<i class="el-icon-upload el-icon--right"></i></el-button>
	              <div style="width: 100%;">{{form.music}}</div>
	              <div slot="tip" class="el-upload__tip">仅支持mp3格式，不大于2M</div>
	            </el-upload>
	          </div>
	        </el-form-item>
	        <el-form-item label="音乐是否自动播放：">
	          <div class="imgbox">
	            <el-switch
	  
	              v-model="form.auto_start"
	              active-color="#13ce66"
	              inactive-color="#ff4949"
	              active-value="1"
	              inactive-value="2"
	              active-text="自动播放"
	              inactive-text="手动">
	            </el-switch>
	          </div>
	        </el-form-item>
	     
	      </el-form>
	    </div>
	    <div class="flx-r">
	      <div class="tips">
	        <p>扫对应的码预览皮肤效果;</p>
	      </div>
	      <div class="qcodeFlx">
	        <div class="qcodeBox">
	          <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=1&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	            :logoScale="0.2" :size="160"></vue-qr>
	            <div class="desc">微信扫一扫预览大转盘</div>
	        </div>
	        <div class="qcodeBox">
	          <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=2&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	            :logoScale="0.2" :size="160"></vue-qr>
	            <div class="desc">微信扫一扫预览九宫格</div>
	        </div>
	        <div class="qcodeBox">
	          <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=3&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	            :logoScale="0.2" :size="160"></vue-qr>
	            <div class="desc">微信扫一扫预览摇一摇</div>
	        </div>
	        <div class="qcodeBox">
	          <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=4&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	            :logoScale="0.2" :size="160"></vue-qr>
	            <div class="desc">微信扫一扫预览扭蛋机</div>
	        </div>
	  	  <div class="qcodeBox">
	  	    <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=5&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	  	      :logoScale="0.2" :size="160"></vue-qr>
	  	      <div class="desc">微信扫一扫预览盲盒</div>
	  	  </div>
	  	  <div class="qcodeBox">
	  	    <vue-qr ref="Qrcode" :text="'https://ndj-api.zjjunlv.com/skin_demo?type=6&id='+form.id" :margin="0" colorDark="#333333" colorLight="#ffffff" :logoSrc="icon"
	  	      :logoScale="0.2" :size="160"></vue-qr>
	  	      <div class="desc">微信扫一扫预览砸金蛋</div>
	  	  </div>
	      </div>
	    </div>
	  
	  </div>
	  
	  <span slot="footer" class="dialog-footer">
	    <el-button @click="dialogVisible = false">取 消</el-button>
	    <el-button type="primary" @click="onSubmit()">保  存</el-button>
	  </span>
	</el-dialog>
	
    <LoginBox ref="login"></LoginBox>
  </div>
</template>
<script>
import { getDZPDIY, postDZPDIY, baseUrl, getMYDIYLIST, postDzpSkinDel  } from '../api/api'
import LoginBox from './loginBox.vue'
import VueQr from 'vue-qr'
import icon from '../assets/image/logo.png'
export default {
  name: 'diyskin',
  data() {
    return {
      baseUrl: baseUrl,
      hasLoad: true,
      icon: icon,
      headers: {
        'x-token': ''
      },
	  skinList:[],
	  dialogVisible:false,
	  loading:true,
      defaultForm: {
        id: '',
        title: '自定义皮肤',
        preview_img: 'https://static.goubudian.com/Uploads/lottery/2305/6466f1ac343f9.jpg', // 大转盘预览禁止修改
        nine_preview_img: 'https://static.goubudian.com/Uploads/lottery/2305/6466f1ac343f9.jpg', // 九宫格预览禁止修改
        create_bg_img: 'https://static.goubudian.com/Uploads/lottery/2305/6466f1ed94e63.jpg', // 创建页预览禁止修改
        bg_color_1: '#fcfdfd', // 转盘1颜色
        bg_color_2: '#fce2d7', // 转盘2颜色
        bg_color_3: '#fdf4dc', // 转盘3颜色
        font_color: '#cd4f68,#cd4f68,#cd4f68', // 转盘字体颜色
        detail_bg_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda7c030b6c.jpg', // 活动页背景图
        detail_bg_color: '#ff2e53', // 活动页背景颜色
        dzp_dial_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda63a2eb35.png', // 转盘盘面背景
        dzp_needle_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda641147ab.png', // 转盘指针
        prize_bg_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda687e53ab.png', // 奖品介绍背景图
        prize_bg_color: 'color: #ffffff;height: 95rpx; line-height: 80rpx;', // 奖品介绍背景颜色 禁止修改
        prize_memo_style: 'background:#f9f9fc;', //  样式 禁止修改
        dzp_memo_style: 'background:#f9f9fc;', // 样式 禁止修改
        win_bg_img: 'https://static.ccxia.cn/Uploads/lottery/2206/62bd38a548af7.png', //  中奖框背景禁止修改
        win_font_bg_img: 'https://static.ccxia.cn/Uploads/lottery/2206/62bd6e9713974.png', // 中奖名称背景 禁止修改
        win_btn_img: 'https://static.ccxia.cn/Uploads/lottery/2206/62bd38ab2dd2f.png', // 中奖按钮 禁止修改
        win_btn_font_style: 'color:#ffffff;', // 样式禁止修改
        win_btn_style: 'background: #dc1a33;color: #ffffff;', // 按钮样式禁止修改
        win_num_style: 'color: #dc1a33;border-color: #dc1a33;', // 中奖样式禁止修改
        win_alert_style: 'color: #dc1a33;', // 样式禁止修改
        win_prize_name_style: 'color: #dc1a33;', //  样式禁止修改
        win_list_bg_style: 'background:rgba(0,0,0,0.1)', //  样式禁止修改
        music: '', // 背景音乐
        nine_dial_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda6454e684.png', // 九宫格盘面背景
        nine_needle_img: 'https://static.goubudian.com/Uploads/lottery/2208/62fda649126f2.png', // 九宫格按钮
        nine_prize_bg: 'https://static.goubudian.com/Uploads/lottery/2208/62fda64d62bef.png', // 九宫格中奖背景
        yao_handle: 'https://static.goubudian.com/Uploads/lottery/2208/62fda65196938.png', // 摇一摇手势
        yao_bottom: 'https://static.goubudian.com/Uploads/lottery/2208/62fda6597a3ac.png', // 摇一摇 底部
        yao_preview_img: 'https://static.goubudian.com/Uploads/lottery/2305/6466f1ac343f9.jpg', // 摇一摇 预览 禁止修改
        niu_preview_img: 'https://static.goubudian.com/Uploads/lottery/2305/6466f1ac343f9.jpg', // 扭蛋机 预览 禁止修改
        niu_boxer: 'https://static.goubudian.com/Uploads/lottery/2208/62fda65dac090.png', // 扭蛋机盒子
        niu_ball1: 'https://static.goubudian.com/Uploads/lottery/2208/62fda6622cff6.png', // 扭蛋机球1
        niu_ball2: 'https://static.goubudian.com/Uploads/lottery/2208/62fda665ab67d.png', // 扭蛋机球2
        niu_ball3: 'https://static.goubudian.com/Uploads/lottery/2208/62fda6696646c.png', // 扭蛋机球3
        niu_window: 'https://static.goubudian.com/Uploads/lottery/2208/62fda66cf399c.png', // 扭蛋机出口
        niu_start: 'https://static.goubudian.com/Uploads/lottery/2208/62fda6711f76d.png', // 扭蛋机开始
        auto_start: '1' // 音乐是否自动播放
      },
	  form:{},
    }
  },
  components: {
    LoginBox, VueQr
  },
  methods: {
	toCompile(obj){
		this.form = JSON.parse(JSON.stringify(this.defaultForm));
		this.form.id = obj.id;
		this.form.bg_color_1 = obj.bg_color_1;
		this.form.bg_color_2 = obj.bg_color_2;
		this.form.bg_color_3 = obj.bg_color_3;
		this.form.font_color =  obj.font_color;
		this.form.detail_bg_img = obj.detail_bg_img;
		this.form.detail_bg_color = obj.detail_bg_color;
		this.form.dzp_dial_img = obj.dzp_dial_img;
		this.form.dzp_needle_img = obj.dzp_needle_img; 
		this.form.prize_bg_img = obj.prize_bg_img; 
		this.form.music = obj .music;
		this.form.nine_dial_img = obj.nine_dial_img;
		this.form.nine_needle_img = obj.nine_needle_img;
		this.form.nine_prize_bg = obj.nine_prize_bg;
		this.form.yao_handle = obj.yao_handle;
		this.form.yao_bottom = obj.yao_bottom;
		this.form.niu_boxer = obj.niu_boxer;
		this.form.niu_ball1 = obj.niu_ball1;
		this.form.niu_ball2 = obj.niu_ball2;
		this.form.niu_ball3 = obj.niu_ball3;
		this.form.niu_window = obj.niu_window;
		this.form.niu_start = obj.niu_start;
		this.form.auto_start =obj.auto_start;
		
		this.dialogVisible = true;	
	},
	toAdd(){
		this.form = JSON.parse(JSON.stringify(this.defaultForm));
		this.dialogVisible = true;	
	},
    onSubmit() {
      this.postData()
    },
    handleProgress() {
      this.hasLoad = true
      this.$forceUpdate()
    },
    handleDetailBgSuccess(res) {
      if (res.code === 200) {
        this.form.detail_bg_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleDzpDialImgSuccess(res) {
      if (res.code === 200) {
        this.form.dzp_dial_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleDzpNeedleImgSuccess(res) {
      if (res.code === 200) {
        this.form.dzp_needle_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handlePrizeBgImgSuccess(res) {
      if (res.code === 200) {
        this.form.prize_bg_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNineDialImgSuccess(res) {
      if (res.code === 200) {
        this.form.nine_dial_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
        this.$message.error(res.msg)
      }
    },
    handleNineNeedleImgSuccess(res) {
      if (res.code === 200) {
        this.form.nine_needle_img = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNinePrizeBgSuccess(res) {
      if (res.code === 200) {
        this.form.nine_prize_bg = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleYaoHandleSuccess(res) {
      if (res.code === 200) {
        this.form.yao_handle = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleYaoBottomSuccess(res) {
      if (res.code === 200) {
        this.form.yao_bottom = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuBoxerSuccess(res) {
      if (res.code === 200) {
        this.form.niu_boxer = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuNall1Success(res) {
      if (res.code === 200) {
        this.form.niu_ball1 = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuNall2Success(res) {
      if (res.code === 200) {
        this.form.niu_ball2 = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuNall3Success(res) {
      if (res.code === 200) {
        this.form.niu_ball3 = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuWindowSuccess(res) {
      if (res.code === 200) {
        this.form.niu_window = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleNiuStartSuccess(res) {
      if (res.code === 200) {
        this.form.niu_start = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
    handleMusicSuccess(res) {
      if (res.code === 200) {
        this.form.music = res.data.imgurl
        // this.onSubmit()
        this.$message.success('上传成功，请保存后，扫码预览效果')
      } else {
        this.$message.error(res.msg)
      }
    },
	fetchList(){
		if (this.$cookie.getCookie('token')) {
		  this.headers['x-token'] = this.$cookie.getCookie('token')
		}
		getMYDIYLIST({}, this.$cookie.getCookie('token')).then(
		response => {
		  if (response.data.code === 200) {
			  
			this.skinList = response.data.data;
			this.loading = false;
		   //  if (response.data.data && response.data.data.id) {
		   //    this.form = response.data.data
		   //    this.hasLoad = false
		   //    this.$forceUpdate()
		   //  } else {
		   //    console.log('没有自定义皮肤，先生成，然后可编辑')
		   
		   //  }
		  }
		},
		reject => {
		  this.showLogin = false
		  this.noQrcode = true
		}
		)
	},
	toDelete(obj){
		this.$confirm('是否删除该皮肤？', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消'
		})
		  .then(async () => {
			  
		    if (this.$cookie.getCookie('token')) {
		      this.headers['x-token'] = this.$cookie.getCookie('token')
		    }
		    postDzpSkinDel({id:obj.row.id}, this.$cookie.getCookie('token')).then(
		    response => {
			
		      if (response.code === 200) {
		    	  
		    
		    	this.skinList.splice(obj.$index,1);
				this.$forceUpdate()
		    
		      }
		    },
		    reject => {
		      this.showLogin = false
		      this.noQrcode = true
		    }
		    )
		  })
		  .catch(() => {
		  })
		

		
	},
    fetchData() {
      if (this.$cookie.getCookie('token')) {
        this.headers['x-token'] = this.$cookie.getCookie('token')
      }
      getDZPDIY({}, this.$cookie.getCookie('token')).then(
        response => {
          if (response.data.code === 200) {
            if (response.data.data && response.data.data.id) {
              this.form = response.data.data
              this.hasLoad = false
              this.$forceUpdate()
            }
          }
        },
        reject => {
          this.showLogin = false
          this.noQrcode = true
        }
      )
    },
    postData() {
	  this.dialogVisible  = false;
      postDZPDIY(this.form, this.$cookie.getCookie('token')).then(
        response => {
          console.log(response.code)
          if (response.code === 200) {
            this.$alert('保存成功，请扫码预览效果', '提示', {
              confirmButtonText: '好的',
              callback: action => {
              }
            })
            this.fetchList()
          } else {
            this.$message.error(response.data.msg)
          }
        },
        reject => {
          console.log(reject)
          this.$message.error(reject.data.msg)
        }
      )
    },
    login_fn(type) {
      this.showLogin = true
      this.fullscreenLoading = true
      clearInterval(this.checkTime)
      this.fetchQrcode()
    },
    close_Login() {
      this.showLogin = false
      clearInterval(this.checkTime)
    }
  },
  created() {
  },
  mounted() {
    if (this.$cookie.getCookie('token') === '') {
      console.log(this.$cookie.getCookie('token'))
      this.headers['x-token'] = this.$cookie.getCookie('token')
      this.$refs.login.login_fn()
    } else {
      this.fetchList()
    }
  }
}
</script>

<style scoped lang="scss">
.diyContent{
  background: #f2f2f2;
}
.big_tt{

  margin: 0 auto;
  background: #ffffff;
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  height: 100px;
  line-height: 100px;
}
.big_top{
	padding:20px 50px;
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	height: 50px;
}
.diyFlx{
  height: 70vh;
  overflow-y: scroll;
  padding: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  margin: 0 auto;
  background: #ffffff;
  box-sizing: border-box;
  .flx-l{
   
    border-right: 1px solid #f2f2f2;
    .tips{
      padding: 20px;
      margin-bottom: 20px;
      p{
        line-height: 20px;
        color: #ff0000;
        font-size: 14px;
      }
    }
    .imgbox{
        width: 550px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          max-width: 250px;
        }
    }
  }
  .flx-r{
    width: 350px;
    margin-left: 20px;
    .tips{
      padding: 20px;
      margin-bottom: 20px;
      p{
        line-height: 20px;
        color: #ff0000;
        font-size: 14px;
      }
    }
    .qcodeFlx{
      .qcodeBox{
        width: 700px;
        margin: 20px auto 50px;
        .desc{
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        }

      }

    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/DiySkin.vue